import { CiapSelectFieldModel } from 'components/form/field/select/CiapSelectField/CiapSelectField'
import { CidSelectFieldModel } from 'components/form/field/select/CidSelectField/CidSelectField'
import { AtendimentoIndividualViewQuery, TipoAtendimentoEnum } from 'graphql/types.generated'
import { metaPath } from 'util/metaPath'

import { AtendimentoVacinacaoState } from '../atendimento-vacinacao/model'
import { LembreteFormModel } from '../detail/components/modals/lembretes/components/LembreteForm'
import { MedicamentoInterromperFormModel } from '../detail/components/modals/medicamentos/InterromperTratamentoModal'
import { MedicaoAnteriorModel } from '../detail/components/modals/medicoes/model-medicoes'
import { AntecedentesFormModel } from '../detail/soap/antecedentes/AntecedentesForm'
import { AvaliacaoFormModel } from '../detail/soap/avaliacao/AvaliacaoForm'
import { ProblemaCondicaoModel } from '../detail/soap/avaliacao/components/problemas-condicoes/model-problemasCondicoes'
import { FinalizacaoAtendimentoFormModel } from '../detail/soap/finalizacao'
import { ObjetivoFormModel } from '../detail/soap/objetivo'
import { PlanoFormModel } from '../detail/soap/plano/PlanoForm'
import { AcompanhamentoPreNatalModel, PreNatalFormModel } from '../detail/soap/pre-natal/model-preNatal'
import { SubjetivoFormModel } from '../detail/soap/subjetivo'
import { RetificacaoAtendimentoState } from '../model-atendimento'

export type TipoServicoModel = AtendimentoIndividualViewQuery['atendimentoIndividual']['atendimento']['tiposServico'][number]

export const TIPOS_ATENDIMENTO_CONCLUEM_AGENDAMENTO = [
  TipoAtendimentoEnum.CONSULTA_AGENDADA_CUIDADO_CONTINUADO,
  TipoAtendimentoEnum.CONSULTA,
]

export interface SoapState {
  openedAccordions?: (string | number)[]
  antecedentes?: AntecedentesFormModel
  subjetivo?: SubjetivoFormModel
  objetivo?: ObjetivoFormModel
  avaliacao?: AvaliacaoFormModel
  plano?: PlanoFormModel
  finalizacao?: FinalizacaoAtendimentoFormModel
  imprimirAtendimento?: boolean
  lastSaved?: Date
  medicoesAnteriores?: MedicaoAnteriorModel[]
  medicamentosInterromper?: ReadonlyArray<MedicamentoInterromperFormModel>
  lembretes?: ReadonlyArray<LembreteFormModel>
  vacinacao?: AtendimentoVacinacaoState
  preNatal?: PreNatalFormModel
  acompanhamentoPreNatal?: AcompanhamentoPreNatalModel
  problemasECondicoes?: ReadonlyArray<ProblemaCondicaoModel>
  retificacaoAtendimento?: RetificacaoAtendimentoState
}

export const meta = metaPath<SoapState>()

export interface CiapCidPreNatal {
  ciap: CiapSelectFieldModel
  cid: CidSelectFieldModel
}

export interface SoapEditableItem {
  editingId?: ID
}
